import page from "./page";
import validation from "./validation";
import message from "./message";
export const TRANSLATIONS_EN = {
  page,
  validation,
  message,
};
